import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type {
  ImportFindingFileMutation,
  ImportFileInput,
  ImportFileOutputData,
} from '#/graphql/types';
import { importFindingFile } from '#/graphql/mutations';

const q = gql(importFindingFile);

const useImportFindingFileMutation = () => {
  const [mutation, result] = useMutation<ImportFindingFileMutation>(q);
  const importFindingFile = useCallback(
    async (data: ImportFileInput): Promise<ImportFileOutputData | null> => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.importFindingFile', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Import failed';
        throw new Error(errorMessage);
      }

      return get(response, 'data.importFindingFile.data', null);
    },
    [mutation],
  );

  return { importFindingFile, result };
};

export default useImportFindingFileMutation;
